<template>
  <VContainer fluid :class="['pa-0']">
    <MenuItemList
      :category="baseCategory"
      :restrict-expansion="isShopMenu"
      :mobile="mobile"
      @close="emits('close')"
    />
  </VContainer>
</template>

<script setup lang="ts">
import type { CategoryItem } from '~/types/root'
import MenuItemList from '~/components/layout/header/menu/MenuItemList.vue'

interface Props {
  baseCategory: CategoryItem
  mobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  mobile: false,
})

const emits = defineEmits<{
  (e: 'close'): void
}>()

const isShopMenu = computed(() => props.baseCategory.slug?.includes(SHOP_ROOT) ?? false)
</script>

<style lang="scss" scoped>
.side-menu-scroll {
  background: rgb(var(--v-theme-backgroundDiv));
  box-shadow: rgba(0, 0, 0, 0.3) 4px 4px 4px 4px;
  position: fixed;
}
.list-item-category {
  border-bottom: 1px solid rgb(var(--v-theme-border));
}
.section ~ .section {
  margin-top: 24px;
  border-top: 1px solid rgb(var(--v-theme-border));
}
</style> 